<ng-container class="fulfillment-tracker">
  <mat-expansion-panel class="tracker-panel" [expanded]="expanded">
    <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
      <div class="row tracker-header-container">
        <div class="col col-xs-12 col-sm-12 col-md-4 column-title">
          <div class="title-text">
            <ng-container *ngIf="product">
              <glxy-avatar [width]="30" [icon]="product.icon" [name]="product.name"></glxy-avatar>
            </ng-container>
            <span>{{ projectTitle }}</span>
          </div>
        </div>
        <div class="col col-xs-11 col-sm-11 column-progress" [ngClass]="hideAskQuestion ? 'col-md-7' : 'col-md-4'">
          <div class="progress-subtitles">
            <div class="progress-count">
              {{
                'FULFILLMENT_TRACKER.PROGRESS'
                  | translate : { completed: projectProgress.completed, total: projectProgress.total }
              }}
            </div>
            <div class="progress-percentage">{{ projectProgress.progress }}%</div>
          </div>
          <mat-progress-bar mode="determinate" [value]="projectProgress.progress"></mat-progress-bar>
        </div>
        <div class="col col-xs-11 col-sm-11 col-md-4 column-ask-question" *ngIf="!hideAskQuestion">
          <div class="ask-question-text" (click)="handleAskQuestionClicked($event)">
            <mat-icon>comment</mat-icon>
            <span>{{ 'FULFILLMENT_TRACKER.ASK_A_QUESTION' | translate }}</span>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>

    <project-tracker-fulfillment-subtasks [subtasks]="subtasks"></project-tracker-fulfillment-subtasks>
  </mat-expansion-panel>
</ng-container>
